import { createContext, useContext, useState, useEffect } from 'react';
import Session from '../Utills/Session';
 

const QrContext = createContext();
export const useQr = () => useContext(QrContext);

export const QrProvider = ({ children }) => {
  const [qrCodeId, setQrCodeIdState] = useState(null);

  // ✅ On mount, read from localStorage
  useEffect(() => {
    const storedQr = Session.get("qr_code_id");
    if (storedQr) {
      setQrCodeIdState(storedQr);
    }
  }, []);

  // ✅ When setting new QR code, update both state and localStorage
  const setQrCodeId = (newId) => {
    setQrCodeIdState(newId);
    Session.set("qr_code_id", newId);
  };


   // ✅ Add this function
  const clearQrCodeId = () => {
    setQrCodeIdState(null);
    Session.remove("qr_code_id");
  };


  return (
    <QrContext.Provider value={{ qrCodeId, setQrCodeId, clearQrCodeId }}>
      {children}
    </QrContext.Provider>
  );
};
